import { Component, OnInit } from '@angular/core';
import { DateUtilService } from 'gung-common';
import { ListItemRendererComponent } from 'gung-list';
import { first } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';
import { BackendInterceptor } from '../../services/backend-interceptor/backend-interceptor.service';

@Component({
    selector: 'lib-open-order-rows-table',
    templateUrl: './open-order-rows-table.component.html',
    styleUrl: './open-order-rows-table.component.scss',
    standalone: false
})
export class OpenOrderRowsTableComponent extends ListItemRendererComponent<any[]> implements OnInit {
  isSales = false;
  public baseUrl = this.backendInterceptor.getBaseUrl();

  constructor(
    protected authService: AuthService,
    public dateUtilService: DateUtilService,
    protected backendInterceptor: BackendInterceptor
  ) {
    super();
  }

  ngOnInit() {
    this.authService
      .getRoles()
      .pipe(first())
      .subscribe(roles => {
        this.isSales = roles.includes('SALES');
      });
  }
}
